// Billing Determinant Dashboard

import React from "react";

// Custom
import Layout from "../../layout";
import BillingDeterminant from "../../components/billingDeterminantCards/BillingDeterminant";

const BillingDeterminantDashboard: React.FC = () => {
  return (
    <Layout>
      <BillingDeterminant />
    </Layout>
  );
};

export default BillingDeterminantDashboard;
